module.exports = __webpack_public_path__ + "static/media/aircraft-error.536c5183.svg";